import React, { useMemo } from 'react';
import { IconContext } from 'react-icons';
import { MdError } from 'react-icons/md';

interface DangerProps {
  value?: IconContext,
}

const DangerIcon = function DangerIcon({
  value,
}: DangerProps): JSX.Element {
  const contextValue = useMemo(() => ({
    color: '#F97171',
    size: '4rem',
    ...value,
  }), [value]);

  return (
    <IconContext.Provider value={contextValue}>
      <div style={{ textAlign: 'center' }}>
        <MdError />
      </div>
    </IconContext.Provider>
  );
};

DangerIcon.defaultProps = {
  value: {
    color: '#F97171',
    size: '4rem',
  },
};

export default DangerIcon;
